<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3 >
        <h4>Create a new Location</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3>
        <form action="" @submit.prevent="onCreateLocation">
          <v-layout row>
            <v-flex xs12 sm6>
            <v-text-field
              name="locationName"
              label="Name"
              v-model="locationName"
              id="locationName"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="locationStreetAddress"
              label="Stree Address"
              v-model="locationStreetAddress"
              id="locationStreetAddress"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="locationCity"
              label="City"
              v-model="locationCity"
              id="locationCity"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="locationState"
              label="State"
              v-model="locationState"
              id="locationState"
              single-line
              required
            ></v-text-field>
            <v-text-field
              name="locationZipcode"
              label="Zipcode"
              v-model="locationZipcode"
              id="locationZipcode"
              single-line
              required
            ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6>
              <v-btn 
              class="primary" 
              :disabled="!formIsValid"
              type="submit">
                Create Location
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      locationName: '',
      locationStreetAddress: '',
      locationCity: '',
      locationState: '',
      locationZipcode: '',
      dialog: false
    }
  },
  props: ['id'],
  computed: {
    location () {
      return this.$store.getters.loadedLocation(this.id)
    },
    locations () {
      return this.$store.getters.loadedLocations
    },
    formIsValid () {
      return this.locationName !== ''
    }
  },
  methods: {
    onCreateLocation () {
      if (!this.formIsValid) {
        return
      }
      const locationData = {
        title: this.locationName,
        locationStreetAddress: this.locationStreetAddress,
        locationCity: this.locationCity,
        locationState: this.locationState,
        locationZipcode: this.locationZipcode
      }
      this.$store.dispatch('createLocation', locationData)
      this.$router.push('/locations')
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateLocation.vue?6ba321f2